import { render, staticRenderFns } from "./CFRubricModal.vue?vue&type=template&id=1823412f&scoped=true"
import script from "./CFRubricModal.vue?vue&type=script&lang=js"
export * from "./CFRubricModal.vue?vue&type=script&lang=js"
import style0 from "./CFRubricModal.vue?vue&type=style&index=0&id=1823412f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1823412f",
  null
  
)

export default component.exports